import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { i18nStore, setLang } from './i18n'
import './styles/typography.css'
import './styles/language-specific.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 初始化 html lang
if (typeof window !== 'undefined') {
  setLang(i18nStore.lang)
}
